"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSetJitaDisabledRequestStatus = exports.getSetJitaEnabledRequestStatus = exports.getFetchJitaEnabledRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getFetchJitaEnabledRequestStatus = (0, _getRequestStatus.default)(_actions.JitaActionTypes.FETCH_JITA_ENABLED);
exports.getFetchJitaEnabledRequestStatus = getFetchJitaEnabledRequestStatus;
var getSetJitaEnabledRequestStatus = (0, _getRequestStatus.default)(_actions.JitaActionTypes.SET_JITA_ENABLED);
exports.getSetJitaEnabledRequestStatus = getSetJitaEnabledRequestStatus;
var getSetJitaDisabledRequestStatus = (0, _getRequestStatus.default)(_actions.JitaActionTypes.SET_JITA_DISABLED);
exports.getSetJitaDisabledRequestStatus = getSetJitaDisabledRequestStatus;